var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed, makeObservable, override } from 'mobx';
import { QuestionTypeLegacy } from '../../QuestionTypeLegacy';
export class MultipleChoiceLegacy extends QuestionTypeLegacy {
    constructor(parent) {
        super(parent);
        makeObservable(this);
    }
    get allOptions() {
        return this.questionTypeStore.allOptions;
    }
    get legacyImagePlaces() {
        return [
            ['answer1', this.allOptions[0].inner],
            ['answer1Comment', this.allOptions[0].ownAspect.comment],
            ['answer2', this.allOptions[1].inner],
            ['answer2Comment', this.allOptions[1].ownAspect.comment],
            ['answer3', this.allOptions[2].inner],
            ['answer3Comment', this.allOptions[2].ownAspect.comment],
            ['answer4', this.allOptions[3].inner],
            ['answer4Comment', this.allOptions[3].ownAspect.comment],
            ['answer5', this.allOptions[4].inner],
            ['answer5Comment', this.allOptions[4].ownAspect.comment],
            ['answer6', this.allOptions[5].inner],
            ['answer6Comment', this.allOptions[5].ownAspect.comment],
            ['answer7', this.allOptions[6].inner],
            ['answer7Comment', this.allOptions[6].ownAspect.comment],
            ['answer8', this.allOptions[7].inner],
            ['answer8Comment', this.allOptions[7].ownAspect.comment],
            ['answer9', this.allOptions[8].inner],
            ['answer9Comment', this.allOptions[8].ownAspect.comment],
            ['correctComment', this.question.ownAspect.commentCorrect],
            ['generalComment', this.question.ownAspect.comment],
            ['question', this.questionPart.inner],
            ['wrongComment', this.question.ownAspect.commentWrong],
        ];
    }
    get legacyCommentPlaces() {
        return [
            ['answer1', this.allOptions[0].ownAspect.comment],
            ['answer2', this.allOptions[1].ownAspect.comment],
            ['answer3', this.allOptions[2].ownAspect.comment],
            ['answer4', this.allOptions[3].ownAspect.comment],
            ['answer5', this.allOptions[4].ownAspect.comment],
            ['answer6', this.allOptions[5].ownAspect.comment],
            ['answer7', this.allOptions[6].ownAspect.comment],
            ['answer8', this.allOptions[7].ownAspect.comment],
            ['answer9', this.allOptions[8].ownAspect.comment],
            ['correct', this.question.ownAspect.commentCorrect],
            ['general', this.question.ownAspect.comment],
            ['wrong', this.question.ownAspect.commentWrong],
        ];
    }
    get evaltext() {
        let evaltext = '';
        const question = this.question;
        for (let i = 0; i < question.options.length; i++) {
            let evalDigit;
            const { isSelected, shouldBeSelected } = question.options[i];
            if (isSelected && !shouldBeSelected) {
                evalDigit = '0';
            }
            else if (isSelected && shouldBeSelected) {
                evalDigit = '1';
            }
            else if (!isSelected && !shouldBeSelected) {
                evalDigit = '2';
            }
            else if (!isSelected && shouldBeSelected) {
                evalDigit = '3';
            }
            evaltext += evalDigit;
        }
        return evaltext;
    }
    set evaltext(evaltext) {
        const question = this.question;
        for (let i = 0; i < question.options.length; i++) {
            const evalDigit = evaltext.charAt(i);
            const option = question.options[i];
            if (evalDigit === '0' || evalDigit === '1') {
                option.isSelected = true;
            }
        }
    }
}
__decorate([
    override
], MultipleChoiceLegacy.prototype, "legacyImagePlaces", null);
__decorate([
    override
], MultipleChoiceLegacy.prototype, "legacyCommentPlaces", null);
__decorate([
    computed
], MultipleChoiceLegacy.prototype, "evaltext", null);
